import Slider from "../../../../../magnolia-component-library/assets/js/modules/slider";
import Modal from "../../../../../magnolia-component-library/assets/js/utils/classes/Modal";

export default function (el) {
    const modalSliderEl = document.querySelector("#screenshots-modal");
    const slider = new Slider(el);

    if (!modalSliderEl) return;

    const modalSlider = new Slider(modalSliderEl);
    const modal = new Modal(el);

    modal.run();

    slider.events.on("indexChanged", (sliderInfo) => {
        modalSlider.goTo(sliderInfo.displayIndex - 1);
    });
}
